import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Controller } from "react-hook-form";

import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { InputNumber } from "primereact/inputnumber";
import { Checkbox } from "primereact/checkbox";
import {
	Col,
	Form,
	FormGroup,
	OverlayTrigger,
	Row,
	Tooltip,
} from "react-bootstrap";
import {
	CardDescription,
	DropdownFilter,
	MultiSelectFilter,
} from "../../../styled";
import { LimitCharacterDiv } from "../../../../../components/card-list/styles";
import Error from "../../../../../components/Error";

import {
	MdInfoOutline,
	MdOutlineInfo,
	MdOutlineWarningAmber,
} from "react-icons/md";
import { formatDate, formatReal } from "../../../../../../helpers";

import {
	listKnowledges,
	listModalities,
} from "../../../../../services/filters.service";
import { listShortDisciplineManager } from "../../../../../services/discipline.service";
import { listAllShortItemsThemeManager } from "../../../../../services/item.service";
import { IMediaCategory } from "../../../../../models/IMediaCategory";
import { mediaCategory } from "../../../../../services/manager-settings.service";

export function DetailsForm(props: any) {
	const history = useHistory();
	const { t: translation } = useTranslation();
	const {
		updateData = false,
		type,
		formRegister,
		control,
		formErrors,
		handleSetValue,
		itemData,
	} = props;

	const deadlineOptions = [
		{ label: "Pronta Entrega", value: 1 },
		{ label: "20 dias", value: 2 },
	];

	const [categoriesItems, setCategoryItems] = useState<IMediaCategory[]>([]);
	// as areas de conhecimento disponíveis
	const [knowledgesItems, setKnowledgesItems] = useState(undefined);
	// as areas de conhecimento selecionadas
	const [knowledges, setKnowledges] = useState<any[]>([]);

	// as modalidades disponíveis
	// const [modalitiesItems, setModalitiesItems] = useState<any>([]);
	// as modalidades selecionadas
	// const [modalities, setModalities] = useState([]);

	const [disciplineItems, setDisciplinaItems] = useState(undefined);
	const [disciplines, setDisciplines] = useState(undefined);

	const [itemListItems, setitemListItems] = useState(undefined);
	const [items, setItems] = useState(undefined);

	const [countMaterialsUnpublishedStore, setCountMaterialsUnpublishedStore] =
		useState<number>(0);
	const [disablePrice, setDisablePrice] = useState<boolean>(false);
	const [pricePreview, setPricePreview] = useState<any>(0);

	const handleDisableDeadline = () => {
		if (type === "Unity" || type === "Item") {
			if (disciplines) {
				return true;
			} else {
				return false;
			}
		} else if (type === "Object" || type === "Media") {
			if (items) {
				return true;
			} else {
				return false;
			}
		} else {
			return false;
		}
	};

	useEffect(() => {
		if (!itemData) {
			if (type === "Theme") {
				mediaCategory().then((data) => {
					data.categories.map((category: any) => {
						if (category.category_name === "Tema") {
							setPricePreview(category.price);
						}
					});
				});
			}
		} else {
			//     let count = 0;
			//     switch (itemData.type_product) {
			// case "Discipline":
			//     if (itemData.items.length > 0) {
			//         itemData.items.map((unidade: any) => {
			//             if (unidade.medias.length > 0) {
			//                 unidade.medias.map((objeto: any) => {
			//                     if (!objeto.is_published_store) {
			//                         count ++
			//                     }
			//                 })
			//             }
			//         })
			//     }
			//     setCountMaterialsUnpublishedStore(count)
			//     break;
			// case "Item":
			//     if (itemData.medias.length > 0) {
			//         itemData.medias.map((objeto: any) => {
			//             if (!objeto.is_published_store) {
			//                 count ++
			//             }
			//         })
			//     }
			//     setCountMaterialsUnpublishedStore(count)
			//     break;
			//     case "Theme":
			//         console.log('tema')
			//         break;
			//     case "Media":
			//         break;
			// }

			setPricePreview(itemData?.price_preview);
		}

		// Carregar lista de areas de conhecimento
		// listKnowledges().then((data) => setKnowledgesItems(data));

		// Carregar lista de modalidades
		// listModalities().then((data) => setModalitiesItems(data));
		// setModalitiesItems(listModalities());
	}, []);

	useEffect(() => {
		if (updateData) {
			// Carregar lista de areas de conhecimento
			listKnowledges().then((data) => setKnowledgesItems(data));

			// // Carregar lista de modalidades
			// listModalities().then((data) => setModalitiesItems(data));

			if (type === "Unity" || type === "Item" || type === "Theme") {
				listShortDisciplineManager({ get_all: "True" }).then((data) => {
					setDisciplinaItems(data);
				});
			} else if (
				!itemListItems &&
				(type === "Object" || type === "Media")
			) {
				listAllShortItemsThemeManager({ get_all: "True" }).then(
					(data) => {
						setitemListItems(data);
					}
				);
			}
		}
	}, [updateData]);

	useEffect(() => {
		if (
			updateData &&
			!disciplineItems &&
			(type === "Unity" || type === "Item" || type === "Theme")
		) {
			listShortDisciplineManager({ get_all: "True" }).then((data) => {
				setDisciplinaItems(data);
			});
		} else if (
			updateData &&
			!itemListItems &&
			(type === "Object" || type === "Media")
		) {
			listAllShortItemsThemeManager({ get_all: "True" }).then((data) => {
				setitemListItems(data);
			});
		}
	}, [type]);

	useEffect(() => {
		if (itemData) {
			if (itemData.discipline) {
				setDisciplines(itemData.discipline);
				handleSetValue("discipline", itemData.discipline);
			}

			if (itemData.item) {
				setItems(itemData.item);
				handleSetValue("item", itemData.item);
			}

			if (itemData.knowledge_area) {
				let knowledgeList: any[] = [];
				itemData.knowledge_area.map((area: any) => {
					knowledgeList.push(area.id);
				});
				setKnowledges([...knowledgeList]);
				handleSetValue("knowledge_area", knowledgeList);
			}

			// if (itemData.modalities) {
			// 	setModalities(itemData.modalities);
			// 	handleSetValue("modalities", itemData.modalities);
			// }

			if (itemData.is_base_price) {
				setDisablePrice(itemData.is_base_price);
			}
		}
	}, [itemData]);

	return (
		<>
			<CardDescription style={{ fontSize: "14px" }}>
				<div
					className="title mb-2"
					style={{ fontSize: "16px" }}
				>
					<MdOutlineInfo
						fontSize={20}
						style={{ marginTop: "-5px" }}
					></MdOutlineInfo>{" "}
					Detalhes
				</div>
				<Row className="mb-2">
					<Col
						md={6}
						className="mb-2"
					>
						{updateData ? (
							<FormGroup>
								<Form.Label>Código</Form.Label>
								<Form.Control
									id="code"
									type="text"
									defaultValue={itemData?.code}
									{...formRegister("code", {
										required: true,
									})}
								></Form.Control>
								{formErrors.code ? (
									<div className="w-100">
										{" "}
										<Error>
											{formErrors.code?.message}
										</Error>{" "}
									</div>
								) : (
									""
								)}
							</FormGroup>
						) : (
							<>
								{itemData?.code &&
								itemData?.code.length > 30 ? (
									<OverlayTrigger
										placement={"top"}
										overlay={
											<Tooltip id={`tooltip-materials`}>
												{itemData?.code}
											</Tooltip>
										}
									>
										<LimitCharacterDiv
											style={{
												fontSize: 14,
												maxWidth: 440,
											}}
										>
											<b>Código:</b> {itemData?.code}
										</LimitCharacterDiv>
									</OverlayTrigger>
								) : (
									<div>
										<p className="mb-0">
											<b>Código: </b>
											{itemData?.code}
										</p>
									</div>
								)}
							</>
						)}
					</Col>

					{type === "Discipline" && (
						<Col
							md={6}
							className="mb-2"
						>
							{updateData ? (
								<FormGroup className="mb-2">
									<Form.Label>Carga Horária</Form.Label>
									<Form.Control
										id="workload"
										type="number"
										defaultValue={itemData?.workload}
										{...formRegister("workload", {
											required: true,
										})}
									></Form.Control>
									{formErrors.workload ? (
										<div className="w-100">
											{" "}
											<Error>
												{formErrors.workload?.message}
											</Error>{" "}
										</div>
									) : (
										""
									)}
								</FormGroup>
							) : (
								<>
									<span>
										<b>Carga Horária:</b>{" "}
										{itemData?.workload} horas
									</span>
								</>
							)}
						</Col>
					)}

					{(type === "Unity" || type === "Item") && (
						<Col
							md={6}
							className="mb-2"
						>
							{updateData ? (
								<FormGroup className="mb-2">
									<Form.Label>
										{translation("manager.type.discipline")}
									</Form.Label>
									<DropdownFilter>
										<Dropdown
											showClear
											optionLabel="title"
											optionValue="id"
											emptyMessage="Nenhuma unidade/tema"
											value={disciplines}
											options={disciplineItems}
											filter
											filterBy="title"
											onChange={(e) => {
												setDisciplines(e.value);
												handleSetValue(
													"discipline",
													e.value
												);
											}}
											placeholder={translation(
												"manager.selects.discipline"
											)}
										/>
										{formErrors.discipline ? (
											<div className="w-100">
												{" "}
												<Error>
													{
														formErrors.discipline
															?.message
													}
												</Error>{" "}
											</div>
										) : (
											""
										)}
									</DropdownFilter>
								</FormGroup>
							) : (
								<span className="span-ellipsis">
									<b>
										{translation("manager.type.discipline")}
										:
									</b>{" "}
									{itemData?.discipline_name}
								</span>
							)}
						</Col>
					)}

					{(type === "Object" || type === "Media") && (
						<Col
							md={6}
							className="mb-2"
						>
							{updateData ? (
								<FormGroup className="mb-2">
									<Form.Label>
										{translation("manager.type.unityTheme")}
									</Form.Label>
									<DropdownFilter>
										<Dropdown
											showClear
											optionLabel="title"
											optionValue="id"
											value={items}
											options={itemListItems}
											onChange={(e) => {
												setItems(e.value);
												handleSetValue("item", e.value);
											}}
											placeholder={translation(
												"manager.selects.unityTheme"
											)}
											filter
											filterBy="title"
										/>
										{formErrors.item ? (
											<div className="w-100">
												{" "}
												<Error>
													{formErrors.item?.message}
												</Error>{" "}
											</div>
										) : (
											""
										)}
									</DropdownFilter>
								</FormGroup>
							) : (
								<span className="span-ellipsis">
									<b>
										{translation("manager.type.unityTheme")}
										:
									</b>{" "}
									{itemData?.item_name}
								</span>
							)}
						</Col>
					)}

					{!updateData && (
						<>
							<Col
								md={6}
								className="mb-2"
							>
								{itemData?.responsible_name.length > 30 ? (
									<OverlayTrigger
										placement={"top"}
										overlay={
											<Tooltip id={`tooltip-materials`}>
												{itemData?.responsible_name}
											</Tooltip>
										}
									>
										<LimitCharacterDiv
											style={{
												fontSize: 14,
												maxWidth: 440,
											}}
										>
											<b>Criado por:</b>{" "}
											{itemData?.responsible_name}
										</LimitCharacterDiv>
									</OverlayTrigger>
								) : (
									<div>
										<p className="mb-0">
											<b>Criado por: </b>
											{itemData?.responsible_name}
										</p>
									</div>
								)}
							</Col>
							<Col
								md={6}
								className="mb-2"
							>
								<span>
									<b>Publicação:</b> {itemData?.status}
								</span>
							</Col>
							<Col
								md={6}
								className="mb-2"
							>
								<span>
									<b>Últimas atualizações:</b>{" "}
									{formatDate(itemData?.updated_at)}
								</span>
							</Col>
						</>
					)}

					<Col
						md={6}
						className="mb-2"
					>
						{updateData ? (
							<FormGroup>
								<Form.Label>Área de conhecimento</Form.Label>
								<MultiSelectFilter>
									<MultiSelect
										value={knowledges}
										maxSelectedLabels={2}
										selectedItemsLabel={
											"{0} " +
											translation("filters.selectedLabel")
										}
										optionLabel="description"
										optionValue="id"
										placeholder={translation(
											"filters.knowledge"
										)}
										className="multiselect-dropdown ds-select"
										options={knowledgesItems}
										onChange={(event: any) => {
											setKnowledges(event.value);
											handleSetValue(
												"knowledge_area",
												event.value
											);
										}}
										filter
									/>
									{formErrors.knowledge_area ? (
										<div className="w-100">
											{" "}
											<Error>
												{
													formErrors.knowledge_area
														?.message
												}
											</Error>{" "}
										</div>
									) : (
										""
									)}
								</MultiSelectFilter>
							</FormGroup>
						) : (
							<>
								<span>
									<b>Área de conhecimento: </b>
									{!!itemData?.knowledge_area?.length &&
										itemData?.knowledge_area?.map(
											(knowledge: any, index: number) => (
												<>
													{knowledge.description +
														(itemData
															?.knowledge_area
															?.length > 1
															? itemData
																	?.knowledge_area
																	?.length ===
															  index + 1
																? " "
																: ", "
															: " ")}
												</>
											)
										)}
								</span>
							</>
						)}
					</Col>

					<Col md={6}>
						{updateData ? (
							<FormGroup className="mb-2">
								<Form.Label>Prazo</Form.Label>
								<Controller
									name="deadline"
									control={control}
									rules={{ required: true }}
									defaultValue={itemData?.deadline}
									render={({ field }) => (
										<>
											<DropdownFilter>
												<Dropdown
													value={field.value}
													onChange={field.onChange}
													options={deadlineOptions}
													placeholder="Prazo"
													disabled={handleDisableDeadline()}
												/>
											</DropdownFilter>
											{handleDisableDeadline() && (
												<div
													className="mt-2"
													style={{
														fontSize: "16px",
														color: "#F39035",
													}}
												>
													<MdInfoOutline
														className="mb-1 mr-1"
														size="20"
													/>{" "}
													O prazo do material
													vinculado será replicado a
													este material.
												</div>
											)}
											{formErrors.deadline ? (
												<div className="w-100">
													{" "}
													<Error>
														{
															formErrors.deadline
																?.message
														}
													</Error>{" "}
												</div>
											) : (
												""
											)}
										</>
									)}
								/>
							</FormGroup>
						) : (
							<span>
								<b>Prazo:</b>{" "}
								{itemData?.deadline && itemData?.deadline === 1
									? "Pronta Entrega"
									: itemData?.deadline === 2
									? "20 dias"
									: "Não informado"}
							</span>
						)}
					</Col>

					<Col
						xs={updateData ? 6 : 12}
						className={updateData ? "" : "mt-3"}
					>
						{updateData ? (
							<>
								{type === "Theme" && (
									<>
										{itemData && itemData?.responsible ? (
											<FormGroup className="mb-2">
												<Form.Label>
													Preço do Material
												</Form.Label>
												<Controller
													name="price"
													control={control}
													rules={{ required: true }}
													defaultValue={
														itemData?.price
													}
													render={({ field }) => (
														<>
															<InputNumber
																value={
																	field.value
																}
																onValueChange={
																	field.onChange
																}
																disabled={
																	disablePrice
																}
																className="input-material-price w-100"
																placeholder="R$ 0,00"
																mode="currency"
																currency="BRL"
																locale="pt-BR"
															/>
															{formErrors.price ? (
																<div className="w-100">
																	{" "}
																	<Error>
																		{
																			formErrors
																				.price
																				?.message
																		}
																	</Error>{" "}
																</div>
															) : (
																""
															)}
														</>
													)}
												/>
												{formErrors.price ? (
													<div className="w-100">
														{" "}
														<Error>
															{
																formErrors.price
																	?.message
															}
														</Error>{" "}
													</div>
												) : (
													""
												)}

												<Checkbox
													inputId="base_price"
													className="mt-2 mr-1"
													checked={disablePrice}
													onChange={() => {
														if (!disablePrice) {
															if (itemData) {
																handleSetValue(
																	"price",
																	itemData?.price_preview
																);
															} else {
																handleSetValue(
																	"price",
																	pricePreview
																);
															}
														} else {
															if (itemData) {
																handleSetValue(
																	"price",
																	itemData?.price
																);
															} else {
																handleSetValue(
																	"price",
																	0
																);
															}
														}
														setDisablePrice(
															!disablePrice
														);
														handleSetValue(
															"is_base_price",
															!disablePrice
														);
													}}
												/>
												<label htmlFor="base_price">
													Utilizar preço base
												</label>
											</FormGroup>
										) : (
											<FormGroup className="mb-2">
												<Form.Label>
													Preço do Material
												</Form.Label>
												<Controller
													name="price"
													control={control}
													rules={{ required: true }}
													defaultValue={
														itemData?.price
													}
													render={({ field }) => (
														<>
															<InputNumber
																value={
																	field.value
																}
																onValueChange={
																	field.onChange
																}
																disabled={
																	disablePrice
																}
																className="input-material-price w-100"
																placeholder="R$ 0,00"
																mode="currency"
																currency="BRL"
																locale="pt-BR"
															/>
															{formErrors.price ? (
																<div className="w-100">
																	{" "}
																	<Error>
																		{
																			formErrors
																				.price
																				?.message
																		}
																	</Error>{" "}
																</div>
															) : (
																""
															)}
														</>
													)}
												/>
												{formErrors.price ? (
													<div className="w-100">
														{" "}
														<Error>
															{
																formErrors.price
																	?.message
															}
														</Error>{" "}
													</div>
												) : (
													""
												)}

												<Checkbox
													inputId="base_price"
													className="mt-2 mr-1"
													checked={disablePrice}
													onChange={() => {
														if (!disablePrice) {
															if (itemData) {
																handleSetValue(
																	"price",
																	itemData?.price_preview
																);
															} else {
																handleSetValue(
																	"price",
																	pricePreview
																);
															}
														} else {
															handleSetValue(
																"price",
																0
															);
														}
														setDisablePrice(
															!disablePrice
														);
														handleSetValue(
															"is_base_price",
															!disablePrice
														);
													}}
												/>
												<label htmlFor="base_price">
													Utilizar preço base
												</label>
											</FormGroup>
										)}
									</>
								)}

								{(type === "Discipline" || type === "Item") && (
									<>
										{itemData?.price ? (
											<div className="d-flex align-items-center mt-4">
												<p className="mr-1 mb-0">
													Preço estimado:
												</p>
												<h3 className="text-darker-grey mb-0">
													<b className="mr-2">
														R${" "}
														{formatReal(
															itemData?.price
														)}
													</b>
													{(type === "Discipline" ||
														type === "Item") && (
														<OverlayTrigger
															overlay={
																<Tooltip id="tooltip-disabled">
																	O preço da{" "}
																	{type ===
																	"Discipline"
																		? "disciplina"
																		: "unidade"}{" "}
																	é calculado
																	pelo soma
																	dos valores
																	dos objetos
																	nela
																	contidos.
																</Tooltip>
															}
														>
															<span
																className="d-inline-block"
																style={{
																	color: "#F39035",
																}}
															>
																<MdInfoOutline className="mb-1" />
															</span>
														</OverlayTrigger>
													)}
												</h3>
											</div>
										) : (
											<>
												<div className="mt-3">
													<span
														className="font-14"
														style={{
															color: "#F39035",
														}}
													>
														Material sem preço
														cadastrado&nbsp;
														<OverlayTrigger
															overlay={
																<Tooltip id="tooltip-disabled">
																	O preço do
																	material é
																	calculado
																	automaticamente
																	com base no
																	preço dos
																	objetos
																	vinculados.
																</Tooltip>
															}
														>
															<span className="d-inline-block ml-1">
																<MdInfoOutline
																	size={16}
																/>
															</span>
														</OverlayTrigger>
													</span>
												</div>
											</>
										)}
									</>
								)}
							</>
						) : (
							<>
								{itemData && itemData?.price !== null ? (
									<Row>
										<Col
											xs={12}
											md={8}
										>
											{itemData?.price_publish !== null &&
											itemData?.price_publish !==
												itemData?.price ? (
												<>
													<p className="">
														<b>Preço estimado:</b>{" "}
														R${" "}
														{formatReal(
															itemData?.price
														)}
													</p>
													<div className="d-flex align-items-center">
														<p className="mr-1 mb-0">
															<b>Preço:</b>
														</p>
														<h3 className="text-darker-grey mb-0 ">
															<b className="mr-2">
																R${" "}
																{formatReal(
																	itemData?.price_publish
																)}
															</b>
															{(type ===
																"Discipline" ||
																type ===
																	"Item") &&
																itemData?.price_publish !==
																	null && (
																	<OverlayTrigger
																		overlay={
																			<Tooltip id="tooltip-disabled">
																				Valor
																				referente
																				a
																				soma
																				dos
																				materiais
																				publicados.
																			</Tooltip>
																		}
																	>
																		<span
																			className="d-inline-block"
																			style={{
																				color: "#DD7B2A",
																			}}
																		>
																			<MdInfoOutline className="mb-1" />
																		</span>
																	</OverlayTrigger>
																)}
														</h3>
													</div>
												</>
											) : (
												<div className="d-flex align-items-center">
													<p className="mr-1 mb-0">
														<b>Preço:</b>
													</p>
													<h3 className="text-darker-grey mb-0 ">
														<b className="mr-2">
															R${" "}
															{formatReal(
																itemData?.price
															)}
														</b>
													</h3>
												</div>
											)}
										</Col>
										{itemData?.materials_not_published >
											0 && (
											<Col
												xs={12}
												md={4}
												className="d-flex align-items-end justify-content-end"
											>
												<div
													className=""
													style={{ color: "#C75136" }}
												>
													<MdOutlineWarningAmber
														size="25"
														className="mr-1"
													/>
													<span>
														{
															itemData?.materials_not_published
														}{" "}
														{itemData?.materials_not_published ===
														1
															? "material não publicado"
															: "materiais não publicados"}{" "}
														na loja
													</span>
												</div>
											</Col>
										)}
									</Row>
								) : (
									<>
										{type === "Discipline" ||
										type === "Item" ? (
											<span
												className="font-14"
												style={{ color: "#F39035" }}
											>
												Material sem preço
												cadastrado&nbsp;
												<OverlayTrigger
													overlay={
														<Tooltip id="tooltip-disabled">
															O preço do material
															é calculado
															automaticamente com
															base no preço dos
															objetos vinculados.
														</Tooltip>
													}
												>
													<span className="d-inline-block ml-1">
														<MdInfoOutline
															size={16}
														/>
													</span>
												</OverlayTrigger>
											</span>
										) : (
											<>
												<div className="mt-3 mb-2">
													<span className="text-dark-grey">
														Preço não cadastrado
													</span>
												</div>
												<span
													className="font-14"
													style={{ color: "#F39035" }}
												>
													Preço base não
													definido&nbsp;
													<OverlayTrigger
														overlay={
															<Tooltip id="tooltip-disabled">
																{type ===
																"Theme"
																	? "Configure o preço do tema"
																	: "Configure o preço dos objetos. Pois o preço das unidades e disciplinas é calculado automaticamente."}
															</Tooltip>
														}
													>
														<span className="d-inline-block ml-1">
															<MdInfoOutline
																size={16}
															/>
														</span>
													</OverlayTrigger>
													<a
														className="text-blueberry cursor-pointer ml-1"
														onClick={() =>
															history.push(
																"/manager/settings?pricingTab=true"
															)
														}
													>
														Configurar
													</a>
												</span>
											</>
										)}
									</>
								)}
							</>
						)}
					</Col>

					{/* Nível de formação/Modalidade - Graduação, pós, técnico */}
					{/* Por enquanto nao editável, herda do curso vinculado na deduca */}
					{/* {type === "Discipline" && (
						<Col
							md={6}
							className="mt-2"
						>
							{updateData ? (
								<FormGroup className="mb-2">
									<Form.Label>Nível de formação</Form.Label>
									<MultiSelectFilter>
										<MultiSelect
											value={modalities}
											maxSelectedLabels={3}
											optionLabel="description"
											optionValue="id"
											placeholder={`Selecione um nível de formação`}
											className="multiselect-dropdown ds-select"
											options={modalitiesItems}
											onChange={(event: any) => {
												setModalities(event.value);
												handleSetValue(
													"modalities",
													event.value
												);
											}}
											filter
										/>
										{formErrors.modalities ? (
											<div className="w-100">
												{" "}
												<Error>
													{
														formErrors.modalities
															?.message
													}
												</Error>{" "}
											</div>
										) : (
											""
										)}
									</MultiSelectFilter>
								</FormGroup>
							) : (
								<>
									<span>
										<b>Nível de formação:</b>{" "}
										{itemData?.modalities.join(", ") ??
											"Por enquanto nao tem"}
									</span>
								</>
							)}
						</Col>
					)} */}
				</Row>
			</CardDescription>
		</>
	);
}
